<template>
  <svg
    v-show="active"
    id="ecpRQZvl5Md1"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter id="ecpRQZvl5Md2-filter" height="400%" width="400%" x="-150%" y="-150%">
        <feComponentTransfer id="ecpRQZvl5Md2-filter-invert-0" result="result">
          <feFuncR id="ecpRQZvl5Md2-filter-invert-0-R" tableValues="0 1" type="table" />
          <feFuncG id="ecpRQZvl5Md2-filter-invert-0-G" tableValues="0 1" type="table" />
          <feFuncB id="ecpRQZvl5Md2-filter-invert-0-B" tableValues="0 1" type="table" />
        </feComponentTransfer>
      </filter>
      <filter id="ecpRQZvl5Md7-filter" height="400%" width="400%" x="-150%" y="-150%">
        <feComponentTransfer id="ecpRQZvl5Md7-filter-invert-0" result="result">
          <feFuncR id="ecpRQZvl5Md7-filter-invert-0-R" tableValues="0 1" type="table" />
          <feFuncG id="ecpRQZvl5Md7-filter-invert-0-G" tableValues="0 1" type="table" />
          <feFuncB id="ecpRQZvl5Md7-filter-invert-0-B" tableValues="0 1" type="table" />
        </feComponentTransfer>
      </filter>
    </defs>
    <g
      id="ecpRQZvl5Md2"
      filter="url(#ecpRQZvl5Md2-filter)"
      transform="translate(-.499989 0.000011)"
    >
      <path
        clip-rule="evenodd"
        d="M25.6794,11.9642c1.0941,1.0558,1.0941,2.7676,0,3.8233-.0745.0719-.1522.1389-.2326.2011l.0124.0113-.0119.0118c.0802.062.1577.1289.2321.2007c1.0941,1.0557,1.0941,2.7675,0,3.8233-1.0942,1.0558-2.8682,1.0558-3.9624,0l-4.1825-4.0358l4.1825-4.0357c1.0942-1.0558,2.8682-1.0558,3.9624,0Z"
        fill="#016dbf"
      />
      <path
        clip-rule="evenodd"
        d="M7.32063,20.0358c-1.09417-1.0558-1.09417-2.7676,0-3.8233.07452-.0719.15218-.1389.23257-.201l-.01243-.0114.01194-.0118c-.08021-.062-.15771-.1289-.23208-.2007-1.09417-1.0557-1.09417-2.7675,0-3.8233s2.86817-1.0558,3.96237,0l4.1825,4.0358-4.1825,4.0357c-1.0942,1.0558-2.86819,1.0558-3.96237,0Z"
        fill="#016dbf"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M20.5357,25.1794c-1.0557,1.0941-2.7675,1.0941-3.8233,0-.0719-.0745-.1389-.1522-.201-.2326l-.0114.0124-.0118-.0119c-.062.0802-.1289.1577-.2006.2321-1.0558,1.0941-2.7676,1.0941-3.8234,0-1.0557-1.0942-1.0557-2.8682,0-3.9624L16.5,17.0345l4.0357,4.1825c1.0558,1.0942,1.0558,2.8682,0,3.9624Z"
        fill="#016dbf"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="M12.4643,6.82063c1.0557-1.09417,2.7675-1.09417,3.8233,0c.0719.07452.1389.15218.201.23257L16.5,7.04077l.0118.01194c.062-.08021.1289-.15771.2006-.23208c1.0558-1.09417,2.7676-1.09417,3.8234,0s1.0557,2.8682,0,3.96237L16.5,14.9655L12.4643,10.783c-1.0558-1.09417-1.0558-2.86819,0-3.96237Z"
        fill="#016dbf"
        fill-rule="evenodd"
      />
    </g>
    <g
      id="ecpRQZvl5Md7"
      filter="url(#ecpRQZvl5Md7-filter)"
      opacity="0"
      transform="translate(-.499989 0.000011)"
    >
      <g id="ecpRQZvl5Md8_to" transform="translate(22.017238,15.999949)">
        <path
          clip-rule="evenodd"
          d="M25.6794,11.9642c1.0941,1.0558,1.0941,2.7676,0,3.8233-.0745.0719-.1522.1389-.2326.2011l.0124.0113-.0119.0118c.0802.062.1577.1289.2321.2007c1.0941,1.0557,1.0941,2.7675,0,3.8233-1.0942,1.0558-2.8682,1.0558-3.9624,0l-4.1825-4.0358l4.1825-4.0357c1.0942-1.0558,2.8682-1.0558,3.9624,0Z"
          fill="#000860"
          fill-rule="evenodd"
          transform="translate(-22.017238,-15.999949)"
        />
      </g>
      <g id="ecpRQZvl5Md9_to" transform="translate(10.982751,16.00005)">
        <path
          clip-rule="evenodd"
          d="M7.32063,20.0358c-1.09417-1.0558-1.09417-2.7676,0-3.8233.07452-.0719.15218-.1389.23257-.201l-.01243-.0114.01194-.0118c-.08021-.062-.15771-.1289-.23208-.2007-1.09417-1.0557-1.09417-2.7675,0-3.8233s2.86817-1.0558,3.96237,0l4.1825,4.0358-4.1825,4.0357c-1.0942,1.0558-2.86819,1.0558-3.96237,0Z"
          fill="#000860"
          fill-rule="evenodd"
          transform="translate(-10.982751,-16.00005)"
        />
      </g>
      <g id="ecpRQZvl5Md10_to" transform="translate(16.499987,21.517238)">
        <path
          clip-rule="evenodd"
          d="M20.5357,25.1794c-1.0557,1.0941-2.7675,1.0941-3.8233,0-.0719-.0745-.1389-.1522-.201-.2326l-.0114.0124-.0118-.0119c-.062.0802-.1289.1577-.2006.2321-1.0558,1.0941-2.7676,1.0941-3.8234,0-1.0557-1.0942-1.0557-2.8682,0-3.9624L16.5,17.0345l4.0357,4.1825c1.0558,1.0942,1.0558,2.8682,0,3.9624Z"
          fill="#000860"
          fill-rule="evenodd"
          transform="translate(-16.499987,-21.517238)"
        />
      </g>
      <g id="ecpRQZvl5Md11_to" transform="translate(16.500013,10.482751)">
        <path
          clip-rule="evenodd"
          d="M12.4643,6.82063c1.0557-1.09417,2.7675-1.09417,3.8233,0c.0719.07452.1389.15218.201.23257L16.5,7.04077l.0118.01194c.062-.08021.1289-.15771.2006-.23208c1.0558-1.09417,2.7676-1.09417,3.8234,0s1.0557,2.8682,0,3.96237L16.5,14.9655L12.4643,10.783c-1.0558-1.09417-1.0558-2.86819,0-3.96237Z"
          fill="#000860"
          fill-rule="evenodd"
          transform="translate(-16.500013,-10.482751)"
        />
      </g>
    </g>
  </svg>
</template>

<script lang="ts" setup>
type Props = {
  active?: boolean
}

defineProps<Props>()
</script>

<style lang="css">
/* stylelint-disable */

#ecpRQZvl5Md2 {
  animation: ecpRQZvl5Md2_c_o 800ms linear 1 normal forwards;
}
@keyframes ecpRQZvl5Md2_c_o {
  0% {
    opacity: 1;
  }
  25% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#ecpRQZvl5Md7 {
  animation: ecpRQZvl5Md7_c_o 800ms linear 1 normal forwards;
}
@keyframes ecpRQZvl5Md7_c_o {
  0% {
    opacity: 0;
  }
  12.5% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
  }
  25% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
#ecpRQZvl5Md8_to {
  animation: ecpRQZvl5Md8_to__to 800ms linear 1 normal forwards;
}
@keyframes ecpRQZvl5Md8_to__to {
  0% {
    transform: translate(22.017238px, 15.999949px);
  }
  37.5% {
    transform: translate(22.017238px, 15.999949px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  55% {
    transform: translate(24.017238px, 15.999949px);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  87.5% {
    transform: translate(22.017238px, 15.999949px);
  }
  100% {
    transform: translate(22.017238px, 15.999949px);
  }
}
#ecpRQZvl5Md9_to {
  animation: ecpRQZvl5Md9_to__to 800ms linear 1 normal forwards;
}
@keyframes ecpRQZvl5Md9_to__to {
  0% {
    transform: translate(10.982751px, 16.00005px);
  }
  37.5% {
    transform: translate(10.982751px, 16.00005px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  55% {
    transform: translate(8.982751px, 16.00005px);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  87.5% {
    transform: translate(10.982751px, 16.00005px);
  }
  100% {
    transform: translate(10.982751px, 16.00005px);
  }
}
#ecpRQZvl5Md10_to {
  animation: ecpRQZvl5Md10_to__to 800ms linear 1 normal forwards;
}
@keyframes ecpRQZvl5Md10_to__to {
  0% {
    transform: translate(16.499987px, 21.517238px);
  }
  37.5% {
    transform: translate(16.499987px, 21.517238px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  55% {
    transform: translate(16.499987px, 23.517238px);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  87.5% {
    transform: translate(16.499987px, 21.517238px);
  }
  100% {
    transform: translate(16.499987px, 21.517238px);
  }
}
#ecpRQZvl5Md11_to {
  animation: ecpRQZvl5Md11_to__to 800ms linear 1 normal forwards;
}
@keyframes ecpRQZvl5Md11_to__to {
  0% {
    transform: translate(16.500013px, 10.482751px);
  }
  37.5% {
    transform: translate(16.500013px, 10.482751px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  55% {
    transform: translate(16.500013px, 8.482751px);
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  87.5% {
    transform: translate(16.500013px, 10.482751px);
  }
  100% {
    transform: translate(16.500013px, 10.482751px);
  }
}
</style>
